<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="title">{{ 'tokenRenewal.title' | translate }}</h2>
    <section [hidden]="!(renewalDetail === 'RENEWED')">
        <!-- NEW TOKEN SENT -->
        <div class="infoBox">
            <p id="newTokenSent-msg">{{ 'tokenRenewal.newTokenSent' | translate }}</p>
        </div>
    </section>
    <section [hidden]="!(renewalDetail === 'TIMEOUT')">
        <!-- UNABLE TO RESENT TOKEN, REMINDERS CLOSED DEFINITELY -->
        <div class="infoBox">
            <p id="closedReminder-msg">{{ 'tokenRenewal.closedReminder' | translate }}</p>
        </div>
    </section>
    <section [hidden]="!(renewalDetail === 'INVALID')">
        <!-- INVALID TOKEN, CHECK OTHER RECEIVED TOKEN -->
        <div class="infoBox">
            <p id="invalidTokenUsed-msg">{{ 'tokenRenewal.invalidTokenUsed' | translate }}</p>
        </div>
    </section>
    <section [hidden]="!(renewalDetail === 'UNAUTHORIZED')">
        <!-- UNAUTHORIZED ACCESS -->
        <div class="infoBox">
            <p id="unauthorized-msg">{{ 'tokenRenewal.unauthorized' | translate }}</p>
        </div>
    </section>
    <section [hidden]="!(renewalDetail === 'ENDED_SESSION')">
        <!-- ENDED SESSION -->
        <div class="infoBox">
            <p id="endedSession-msg">{{ 'tokenRenewal.endedSession' | translate }}</p>
        </div>
    </section>
</main>